<kendo-card class="general-grid general-card" [width]="gridWidth">
  <kendo-card-header class="header">
    <kendo-stacklayout class="header-content" [align]="{ horizontal: 'end' }" [orientation]="$orientation()">
      <h2 class="wrap-header">{{ $gridTitle() }}</h2>
      @if ($filterable() !== false) {
        <kendo-textbox
          unityDebounceValueChanges
          placeholder="Search all text columns..."
          [clearButton]="true"
          [class]="$searchbarClass()"
          [(value)]="searchValue"
          (valueChange)="onStartSearch()"
          (debouncedValueChange)="onSearch()">
          <ng-template kendoTextBoxSuffixTemplate>
            @if (this.$isSearchLoading()) {
              <kendo-loader class="search-spinner" type="infinite-spinner" size="small" />
            }
          </ng-template>
        </kendo-textbox>
      }
    </kendo-stacklayout>
  </kendo-card-header>
  <kendo-card-body>
    @let gridDataQuery = $gridDataQuery();
    <kendo-grid
      #grid
      adaptiveMode="auto"
      [scrollable]="$scrollable()"
      [resizable]="false"
      [data]="$gridData()"
      [loading]="$gridLoading()"
      [sortable]="$sortable()"
      [filterable]="$filterable()"
      [groupable]="$groupable()"
      [pageable]="$pageable()"
      [pageSize]="gridDataQuery.take"
      [skip]="gridDataQuery.skip"
      [sort]="gridDataQuery.sort"
      [filter]="gridDataQuery.filter"
      (dataStateChange)="onDataStateChange($event)"
      (cellClick)="onCellClick($event)">
      <ng-template kendoGridNoRecordsTemplate>
        @let error = $gridError();
        <div class="norecords">
          @if (error) {
            {{ error }}
          } @else if (!$gridLoading()) {
            This list is empty right now.
          }
        </div>
      </ng-template>
      <ng-content>
        <!-- wrapping component should define <kendo-grid-column> elements to go here -->
      </ng-content>
    </kendo-grid>
  </kendo-card-body>
</kendo-card>
